import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PoTableColumn } from '@po-ui/ng-components';
import { CONSTANTS } from 'src/app/constants';
import { ApiService } from 'src/app/shared/service/api.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-billing-value',
  templateUrl: './billing-value.component.html',
  styleUrls: ['./billing-value.component.css']
})
export class BillingValueComponent implements OnInit {
  _filterAccomplish: any = {};
  @Input() set filterAccomplish(value: any) {
    this._filterAccomplish = value;
    this.filterItem(this._filterAccomplish);
  }

  @Output() errorEmitter = new EventEmitter();

  topTooltipExcel: string = 'Download .xlsx';

  tableItens!: any;
  getYear!: any;
  getValueDay!: any;
  loading: boolean = true;
  dataMin: any;
  dataMax: any;
  valueItem: any;
  message: string = "";
  errorApi = false;
  columns: Array<PoTableColumn> = [
    { property: 'dia', label: 'Dia' },
    { property: 'quantidade', label: 'Quantidade' },
    { property: 'valor', label: 'Valor R$'},
  ];

  constructor(private api: ApiService) { }

  ngOnInit() {
  }

  filterItem(item: any) {
    if (item.branch != undefined) {
      this.salePweekDay(item).subscribe(data => {
        try {
          this.loading = true;
          this.valueItem = [];
          this.getValueDay = data.dataRow;
          let excelInfo = [];
          let diaSemana = '';
          if (data.dataRow.length != 0) {
            this.getValueDay.map((el: any) => {
              this.valueItem.push(el.invoice_value);
              if (el.saledatetime_weekday == 1) {
                diaSemana = 'Domingo';
              } else if (el.saledatetime_weekday == 2) {
                diaSemana = 'Segunda-Feira';
              } else if (el.saledatetime_weekday == 3) {
                diaSemana = 'Terça-Feira';
              } else if (el.saledatetime_weekday == 4) {
                diaSemana = 'Quarta-Feira';
              } else if (el.saledatetime_weekday == 5) {
                diaSemana = 'Quinta-Feira';
              } else if (el.saledatetime_weekday == 6) {
                diaSemana = 'Sexta-Feira';
              } else if (el.saledatetime_weekday == 7) {
                diaSemana = 'Sábado';
              } else {
                diaSemana = '---';
              }
              excelInfo.push({'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Código Filiais': item.branch.toString(), 'Dia da Semana': diaSemana, 'Quantidade': el.invoice_qty.toString(), 'Valor': 'R$' + el.invoice_value.toString()});
            })
            excelInfo.unshift({});
            localStorage.setItem('billing-value', JSON.stringify(excelInfo));
            this.getDatesFunction();
          } else {
            this.tableItens = [];
            this.loading = false;
            this.message = CONSTANTS.MESSAGES.DATA_NULL_BILLING_VALUE;
            this.formatErrorMensagem(CONSTANTS.MESSAGES.DATA_NULL_BILLING_VALUE);
            this.errorApi = true;
          }
        } catch(error: unknown){
          this.tableItens = [];
          this.loading = false;
          this.message = CONSTANTS.MESSAGES.DATA_ERRO_BILLING_VALUE;
          this.formatErrorMensagem(CONSTANTS.MESSAGES.DATA_ERRO_BILLING_VALUE);
          this.errorApi = true;
          if (error instanceof Error)
            this.formatErrorMensagem(error.message);
        }
      });
    }
  }

  downloadExcel() {
    const EXCEL_TYPE =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';

    let dataBellingValue = [];
    let objectBellingValue = localStorage.getItem('billing-value');

    objectBellingValue != null
      ? (dataBellingValue = JSON.parse(objectBellingValue))
      : (dataBellingValue = []);
    const worksheetBellingValue= XLSX.utils.json_to_sheet(dataBellingValue);

    const workbook = {
      Sheets: {
        'valor-medio-faturado-dia': worksheetBellingValue,
      },
      SheetNames: [
        'valor-medio-faturado-dia',
      ],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'buffer',
    });
    const data: Blob = new Blob([excelBuffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, 'minhas-operacoes-valor-medio-faturado-dia' + EXCEL_EXTENSION);
  }

  getDatesFunction() {
    this.tableItens = [
      {dia: 'Domingo', quantidade: this.getValueDay[0].invoice_qty, valor: parseFloat(this.getValueDay[0].invoice_value).toLocaleString('pt-br', {minimumFractionDigits: 2})},
      {dia: 'Segunda-Feira', quantidade: this.getValueDay[1].invoice_qty, valor: parseFloat(this.getValueDay[1].invoice_value).toLocaleString('pt-br', {minimumFractionDigits: 2})},
      {dia: 'Terça-Feira', quantidade: this.getValueDay[2].invoice_qty, valor: parseFloat(this.getValueDay[2].invoice_value).toLocaleString('pt-br', {minimumFractionDigits: 2})},
      {dia: 'Quarta-Feira',quantidade: this.getValueDay[3].invoice_qty, valor: parseFloat(this.getValueDay[3].invoice_value).toLocaleString('pt-br', {minimumFractionDigits: 2})},
      {dia: 'Quinta-Feira', quantidade: this.getValueDay[4].invoice_qty, valor: parseFloat(this.getValueDay[4].invoice_value).toLocaleString('pt-br', {minimumFractionDigits: 2})},
      {dia: 'Sexta-Feira', quantidade: this.getValueDay[5].invoice_qty, valor: parseFloat(this.getValueDay[5].invoice_value).toLocaleString('pt-br', {minimumFractionDigits: 2})},
      {dia: 'Sábado', quantidade: this.getValueDay[6].invoice_qty, valor: parseFloat(this.getValueDay[6].invoice_value).toLocaleString('pt-br', {minimumFractionDigits: 2})}
    ];
    this.errorApi = false;
    this.loading = false;
  }

  salePweekDay(item: any) {
    return this.api.postWeekdays(item.dataMin, item.dataMax, item.branch, item.sellers);
  }

  formatErrorMensagem(item: any) {
    let dataError = new Date();
    let errorMensagem = "Arquivo: billing-value \r\n" + "Data: " + dataError + "\r\n" + "Mensagem: " + item + "\r\n" + "===============================================" + "\r\n";
    this.errorEmitter.emit(errorMensagem);
  }

}
